/**
 * 订单的业务方归属类型
 * 20.成长加 21.育儿
 */
export const ORDER_BELONG_BUSI_ENUM = {
  /**
   * 20.成长加
   */
  CZJ: 20,
  /**
   * 21.育儿孕产加
   */
  YCJ_YUER: 21,
  /**
   * 21.孕产加活动
   */
  YCJ_ACTIVE: 22,
  /**
   * 21.孕产加游乐
   */
  YCJ_PLAY: 23,
  /**
   * 24.自营摄影
   */
  SELF_PHOTO: 24
}

/**
 * 订单状态
 * 10.待支付 20.待使用 30.待评价 40.已完成 50.已取消
 */
export const ORDER_STATE = new Map([
  [10, '待支付'],
  [20, '待使用'],
  [30, '待评价'],
  [40, '已完成'],
  [50, '已取消'],
  [70, '已过期']
])

/**
 * 订单状态
 * 10.待支付 20.待使用 30.待评价 40.已完成 50.已取消 70.已过期
 */
export const ORDER_STATE_ENUM = {
  /**
   * 10.待支付
   */
  PENDING_PAY: 10,
  /**
   * 20.待使用
   */
  TO_BE_USED: 20,
  /**
   * 30.待评价
   */
  WAITING_4_EVALUATE: 30,
  /**
   * 40.已完成
   */
  FINISHED: 40,
  /**
   * 50.已取消
   */
  CANCELED: 50,
  /**
   * 70.已过期
   */
  EXPIRED: 70
}

/**
 * 退款状态
 * 10.未申请退款 20.已申请退款 30.退款成功 40.退款失败
 */
export const REFUND_STATE = new Map([
  [10, '未申请退款'],
  [20, '已申请退款'],
  [30, '退款成功'],
  [40, '退款失败']
])

/**
 * 退款状态
 * 10.未申请退款 20.已申请退款 30.退款成功 40.退款失败
 */
export const ORDER_REFUND_STATE_ENUM = {
  /**
   * 未申请退款
   */
  NOT_APPLIED: 10,
  /**
   * 已申请退款
   */
  APPLIED: 20,
  /**
   * 退款成功
   */
  SUCCESSED: 30,
  /**
   * 退款失败
   */
  FAILED: 40
}

/**
 * 订单列表按钮类型枚举
 */
export const OrderListActionType_ENUM = {
  /**
   * 立即支付
   */
  TO_PAY: 10,
  /**
   * 我的月嫂（联营月嫂）
   */
  TO_MY_YUESAO: 1001,

  /**
   * 服务日志
   */
  TO_SERVICE_LOG: 1002,
  /**
   * 立即评价
   */
  TO_COMMENT: 30,
  /**
   * 删除订单
   */
  TO_DEL_ORDER: 50,
  /**
   * 拼团详情
   */
  TO_GROUP_DETAIL: 1000,
  /**
   * 预约拍摄（拍摄）
   */
  TO_RESERVE_DATETIME_TAKE_PHOTO: 60,
  /**
   * 修改日期（拍摄）
   */
  TO_MODIFY_DATETIME_TAKE_PHOTO: 70,
  /**
   * 我的相册（拍摄）
   */
  TO_MY_ALBUM: 80
}

/**
 * 订单详情按钮类型枚举
 */
export const OrderDetailActionType_ENUM = {
  /**
   * 立即支付
   */
  TO_PAY: 10,

  /**
   * 支付定金
   */
  TO_PAY_PRE: 11,

  /**
   * 支付尾款
   */
  TO_PAY_REST: 12,

  /**
   * 取消订单
   */
  TO_CANCEL_ORDER: 20,

  /**
   * 确认完成
   */
  TO_CONFIRM_COMPLETED: 30,

  /**
   * 确认收货
   */
  TO_CONFIRM_RECEIVED: 31,

  /**
   * 我的月嫂（联营月嫂）
   */
  TO_MY_YUESAO: 32,

  /**
   * 确认上户
   */
  TO_CONFIRM_YUESAO_DOOR2DOOR: 40,

  /**
   * 查看服务日志
   */
  TO_READ_NEW_YUESAO_LOG: 41,

  /**
   * 确认服务完成
   */
  TO_CONFIRM_SERVICE_COMPLETED: 50,

  /**
   * 服务日志
   */
  TO_SERVICE_LOG: 60,

  /**
   * 申请售后(400电话)
   */
  TO_SERVICE_TEL_NORMAL: 70,

  /**
   * 申请售后
   */
  TO_APPLY_SERVICE_AFTER_SALE_YUESAO: 80,

  /**
   * 取消售后
   */
  TO_CANCEL_SERVICE_AFTER_SALE_YUESAO: 90,

  /**
   * 申请退款
   */
  TO_APPLY_REFUND: 100,

  /**
   * 撤销退款
   */
  TO_CANCEL_APPLY_REFUND: 110,

  /**
   * 立即评价
   */
  TO_COMMENT: 120,

  /**
   * 查看评价
   */
  TO_LOOK_COMMENTS: 130,

  /**
   * 删除订单
   */
  TO_DEL_ORDER: 140,

  /**
   * 预约拍摄（摄影）
   */
  TO_RESERVE_DATETIME_TAKE_PHOTO: 150,
  //  /**
  //  * 修改时间（摄影）
  //  */
  // TO_MODIFY_DATETIME_TAKE_PHOTO: 160,

  /**
   * 我的相册（摄影）
   */
  TO_MY_ALBUM: 170,
  /**
   * 查看保单
   */
  TO_SEE_INSURANCE: 180
}

/**
 * 订单列表按钮全字典(统一全黑圆角线框按钮)
 */
export const AllActionObjsInOrderListItem = new Map([
  [
    OrderListActionType_ENUM.TO_PAY,
    {
      txt: '立即支付',
      actionType: OrderListActionType_ENUM.TO_PAY,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_PAY_PRE,
    {
      txt: '支付定金',
      actionType: OrderListActionType_ENUM.TO_PAY_PRE,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_PAY_REST,
    {
      txt: '支付尾款',
      actionType: OrderListActionType_ENUM.TO_PAY_REST,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_MY_YUESAO,
    {
      txt: '我的月嫂',
      actionType: OrderListActionType_ENUM.TO_MY_YUESAO
    }
  ],
  [
    OrderListActionType_ENUM.TO_SERVICE_LOG,
    {
      txt: '服务日志',
      actionType: OrderListActionType_ENUM.TO_SERVICE_LOG,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_COMMENT,
    {
      txt: '立即评价',
      actionType: OrderListActionType_ENUM.TO_COMMENT,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_GROUP_DETAIL,
    {
      txt: '拼团详情',
      actionType: OrderListActionType_ENUM.TO_GROUP_DETAIL,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_DEL_ORDER,
    {
      txt: '删除订单',
      actionType: OrderListActionType_ENUM.TO_DEL_ORDER
    }
  ],
  [
    OrderListActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO,
    {
      txt: '预约拍摄',
      actionType: OrderListActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO,
    {
      txt: '修改预约',
      actionType: OrderListActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO,
      styleClass: 'btn-highlited'
    }
  ],
  [
    OrderListActionType_ENUM.TO_MY_ALBUM,
    {
      txt: '我的相册',
      actionType: OrderListActionType_ENUM.TO_MY_ALBUM,
      styleClass: 'btn-highlited'
    }
  ]
])

/**
 * 订单详情按钮全字典（有颜色区别）
 */
export const AllActionObjsInOrderDetail = new Map([
  [
    OrderDetailActionType_ENUM.TO_PAY,
    {
      txt: '立即支付',
      actionType: OrderDetailActionType_ENUM.TO_PAY,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_PAY_PRE,
    {
      txt: '支付定金',
      actionType: OrderDetailActionType_ENUM.TO_PAY_PRE,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_PAY_REST,
    {
      txt: '支付尾款',
      actionType: OrderDetailActionType_ENUM.TO_PAY_REST,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CANCEL_ORDER,
    {
      txt: '取消订单',
      actionType: OrderDetailActionType_ENUM.TO_CANCEL_ORDER,
      styleClass: 'btn-cancel'
    }
  ],

  [
    OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED,
    {
      txt: '确认完成',
      actionType: OrderDetailActionType_ENUM.TO_CONFIRM_COMPLETED,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CONFIRM_RECEIVED,
    {
      txt: '确认收货',
      actionType: OrderDetailActionType_ENUM.TO_CONFIRM_RECEIVED,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_MY_YUESAO,
    {
      txt: '我的月嫂',
      actionType: OrderDetailActionType_ENUM.TO_MY_YUESAO,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CONFIRM_YUESAO_DOOR2DOOR,
    {
      txt: '确认上户',
      actionType: OrderDetailActionType_ENUM.TO_CONFIRM_YUESAO_DOOR2DOOR,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_READ_NEW_YUESAO_LOG, // 新版流程的月嫂服务日志
    {
      txt: '服务日志',
      actionType: OrderDetailActionType_ENUM.TO_READ_NEW_YUESAO_LOG,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CONFIRM_SERVICE_COMPLETED,
    {
      txt: '确认服务完成',
      actionType: OrderDetailActionType_ENUM.TO_CONFIRM_SERVICE_COMPLETED,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_SERVICE_TEL_NORMAL,
    {
      txt: '申请售后',
      actionType: OrderDetailActionType_ENUM.TO_SERVICE_TEL_NORMAL,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_APPLY_SERVICE_AFTER_SALE_YUESAO,
    {
      txt: '申请售后',
      actionType: OrderDetailActionType_ENUM.TO_APPLY_SERVICE_AFTER_SALE_YUESAO,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CANCEL_SERVICE_AFTER_SALE_YUESAO,
    {
      txt: '取消售后',
      actionType:
        OrderDetailActionType_ENUM.TO_CANCEL_SERVICE_AFTER_SALE_YUESAO,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_APPLY_REFUND,
    {
      txt: '申请退款',
      actionType: OrderDetailActionType_ENUM.TO_APPLY_REFUND,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_CANCEL_APPLY_REFUND,
    {
      txt: '撤销退款',
      actionType: OrderDetailActionType_ENUM.TO_CANCEL_APPLY_REFUND,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_COMMENT,
    {
      txt: '立即评价',
      actionType: OrderDetailActionType_ENUM.TO_COMMENT,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_LOOK_COMMENTS,
    {
      txt: '查看评价',
      actionType: OrderDetailActionType_ENUM.TO_LOOK_COMMENTS,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_DEL_ORDER,
    {
      txt: '删除订单',
      actionType: OrderDetailActionType_ENUM.TO_DEL_ORDER,
      styleClass: 'btn-cancel'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO,
    {
      txt: '预约拍摄',
      actionType: OrderDetailActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO,
    {
      txt: '修改预约',
      actionType: OrderDetailActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO,
      styleClass: 'btn-pink'
    }
  ],
  [
    OrderDetailActionType_ENUM.TO_SEE_INSURANCE,
    {
      txt: '查看保单',
      actionType: OrderDetailActionType_ENUM.TO_SEE_INSURANCE,
      styleClass: 'btn-cancel'
    }
  ]
])
